import { NavLink, Link } from "react-router-dom";

export const navItems = [
  { to: "/", label: "Welcome" },
  { to: "/start", label: "Enter" },
  { to: "/story", label: "Enter Through Story" },
  { to: "/nations", label: "For Nations" },
  { to: "/design", label: "Girribal Learning" },
  { to: "/architecture", label: "Lore-Led Architecture" },
  { to: "/pricing", label: "Licensing" },
  { to: "/readiness", label: "Readiness" },
  { to: "/assurance", label: "Community Responsibility" },
  { to: "/contact", label: "Request Access" },
];

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function Section({ children, className = "" }) {
  return <section className={cn("mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-20 md:py-24", className)}>{children}</section>;
}

export function Eyebrow({ children }) {
  return (
    <div className="mb-5 inline-flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase font-bold text-stone-500">
      <span className="h-1.5 w-1.5 bg-[#9C4221] rounded-full" />
      {children}
    </div>
  );
}

export function H1({ children, className = "" }) {
  return (
    <h1 className={cn("font-display text-5xl md:text-6xl lg:text-7xl tracking-tighter font-bold text-stone-900 leading-[0.95]", className)}>
      {children}
    </h1>
  );
}

export function H2({ children, className = "" }) {
  return (
    <h2 className={cn("font-display text-4xl md:text-5xl tracking-tighter font-bold text-stone-900 leading-tight max-w-4xl", className)}>
      {children}
    </h2>
  );
}

export function P({ children, className = "" }) {
  return (
    <p className={cn("text-stone-600 text-lg leading-relaxed max-w-2xl", className)}>{children}</p>
  );
}

export function Status({ children, tone = "default" }) {
  const tones = {
    default: "bg-stone-100 text-stone-700 border-stone-300",
    accent: "bg-[#9C4221]/10 text-[#9C4221] border-[#9C4221]/30",
    ready: "bg-emerald-50 text-emerald-900 border-emerald-200",
  };
  return (
    <span className={cn("inline-block text-[10px] tracking-[0.18em] uppercase px-2.5 py-1 border font-bold", tones[tone] || tones.default)}>
      {children}
    </span>
  );
}

export function Card({ children, className = "" }) {
  return (
    <div className={cn("border border-stone-200 bg-[#FAFAF9] p-8 hover-rise", className)}>
      {children}
    </div>
  );
}

export function PageHero({ eyebrow, title, desc }) {
  return (
    <section className="border-b border-stone-200">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-20 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <Eyebrow>{eyebrow}</Eyebrow>
          <H1>{title}</H1>
        </div>
        <div className="lg:col-span-5 flex items-end">
          <P className="text-lg">{desc}</P>
        </div>
      </div>
    </section>
  );
}

export { Link, NavLink };
